module.exports = __webpack_public_path__ + "img/zhyjsjdzgl1.71c890f5.png";